import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Tooltip',
  props: {
  text: {
    type: String,
    required: true,
  },
  position: {
    type: String as PropType<'top' | 'bottom' | 'left' | 'right'>,
    default: 'top',
    required: false
  },
  canShow: {
    type: Boolean,
    default: true,
  }
},
  setup(__props, { expose: __expose }) {
  __expose();

const visible = ref(false);



function hideTooltip() {
  visible.value = false;
}

function showTooltip() {
  visible.value = true;
}

const __returned__ = { visible, hideTooltip, showTooltip }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})